const CommissionRuleList = () =>
    import("@/views/setup/commission/CommissionRuleList.vue");
const addCurrency = () => import("@/views/setup/currency/addCurrency.vue");
const currencyViewDetail = () =>
    import("@/views/setup/currency/currencyViewDetail.vue");
const Resources = () => import("@/views/setup/currency/Resources.vue");
const accessRuleDetails = () =>
    import("@/components/MasterSetup/accessrules/AccessruleDetails.vue");
const accessRuleCreate = () =>
    import("@/components/MasterSetup/accessrules/CreateAccessrule.vue");
const accessRuleEdit = () =>
    import("@/components/MasterSetup/accessrules/EditAccessrule.vue");
const currencyEdit = () => import("@/views/setup/currency/editCurrency.vue");
const concern = () => import("@/views/setup/concern.vue");
const Faq = () => import("@/views/setup/Faq.vue");
const CreateFaq = () => import("@/components/MasterSetup/FAQ/CreateFaq.vue");
const ViewFaq = () => import("@/components/MasterSetup/FAQ/ViewFaq.vue");
const EditFaq = () => import("@/components/MasterSetup/FAQ/EditFaq.vue");
const Taxcode = () => import("@/views/setup/Taxcode.vue");
const ViewTaxCode = () =>
    import("@/components/MasterSetup/TaxCode/ViewTaxCode.vue");
const CreateTaxCode = () =>
    import("@/components/MasterSetup/TaxCode/CreateTaxCode.vue");
const EditTaxCode = () =>
    import("@/components/MasterSetup/TaxCode/EditTaxCode.vue");
const Servicerequest = () => import("@/views/setup/ServiceRequest.vue");
const ViewRequest = () =>
    import("@/components/MasterSetup/ServiceRequest/ViewRequest.vue");
const Subcategory = () =>
    import("@/components/MasterSetup/ServiceRequest/Subcategory.vue");
const EditRequest = () =>
    import("@/components/MasterSetup/ServiceRequest/EditRequest.vue");
const CreateRequest = () =>
    import("@/components/MasterSetup/ServiceRequest/CreateRequest.vue");
const Coupon = () => import("@/views/setup/Coupon.vue");
const CreateCoupon = () =>
    import("@/components/MasterSetup/Coupon/CreateCoupon");
const EditCoupon = () => import("@/components/MasterSetup/Coupon/EditCoupon");
const ViewCoupon = () => import("@/components/MasterSetup/Coupon/ViewCoupon");
const subscriptionplan = () => import("@/views/setup/subscriptionplan.vue");
const CreateSubscriptionplan = () =>
    import("@/components/MasterSetup/subscriptionplan/CreateSubscriptionplan");
const EditSubscriptionplan = () =>
    import("@/components/MasterSetup/subscriptionplan/EditSubscriptionplan");
const ViewSubscriptionplan = () =>
    import("@/components/MasterSetup/subscriptionplan/ViewSubscriptionplan");
const deliverysetup = () => import("@/views/setup/deliverysetup.vue");
const CreateDeliverysetup = () =>
    import("@/components/MasterSetup/deliverysetup/CreateDeliverysetup");
const EditDeliverysetup = () =>
    import("@/components/MasterSetup/deliverysetup/EditDeliverysetup");
const ViewDeliverysetup = () =>
    import("@/components/MasterSetup/deliverysetup/ViewDeliverysetup");
const createCommission = () =>
    import("@/views/setup/commission/CommissionCreate.vue");
const editCommission = () =>
    import("@/views/setup/commission/CommissionEdit.vue");
const viewCommission = () =>
    import("@/views/setup/commission/CommissionView.vue");
const ReturnPolicy = () => import("@/views/setup/return-policy/index.vue");
const CreateReturnPolicy = () =>
    import("@/views/setup/return-policy/create.vue");
const EditReturnPolicy = () => import("@/views/setup/return-policy/edit.vue");
const ViewReturnPolicy = () => import("@/views/setup/return-policy/view.vue");
import workflows from "@/router/workflows";

export default {
    path: "setup",
    meta: { label: "Setup" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "accessrule",
            meta: {
                label: "Access Rule",
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Access Rule",
                    meta: {
                        requiresAuth: true,
                    },
                    component: accessRuleDetails,
                },
                {
                    path: "edit/:id",
                    name: "access rule edit",
                    meta: {
                        label: "Access Rule Edit",
                        requiresAuth: true,
                    },
                    component: accessRuleEdit,
                },
                {
                    path: "create",
                    meta: {
                        label: "Access Rule Create",
                        requiresAuth: true,
                    },
                    component: accessRuleCreate,
                },
            ],
        },
        {
            path: "Resources",
            name: "Resources",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    meta: {
                        requiresAuth: true,
                    },
                    component: Resources,
                },
                {
                    path: "currencyViewDetail/:id",
                    name: "currencyViewDetail",
                    meta: {
                        label: "View",
                        requiresAuth: true,
                    },
                    component: currencyViewDetail,
                },
                {
                    path: "editCurrency/:id",
                    name: "editCurrency",
                    meta: {
                        label: "Edit Currency",
                        requiresAuth: true,
                    },
                    component: currencyEdit,
                },
                {
                    path: "addCurrency",
                    name: "addCurrency",
                    meta: {
                        label: "Add Currency",
                        requiresAuth: true,
                    },
                    component: addCurrency,
                },
            ],
        },
        {
            path: "concern",
            name: "concern",
            meta: {
                requiresAuth: true,
            },
            component: concern,
        },
        {
            path: "faq",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Faqs",
                    meta: {
                        requiresAuth: true,
                    },
                    component: Faq,
                },
                {
                    path: "CreateFaq",
                    name: "CreateFaq",
                    meta: {
                        label: "Create Faq",
                        requiresAuth: true,
                    },
                    component: CreateFaq,
                },
                {
                    path: "ViewFaq",
                    name: "ViewFaq",
                    meta: {
                        label: "View Faq",
                        requiresAuth: true,
                    },
                    component: ViewFaq,
                },
                {
                    path: "EditFaq",
                    name: "EditFaq",
                    meta: {
                        label: "Edit Faq",
                        requiresAuth: true,
                    },
                    component: EditFaq,
                },
            ],
        },
        {
            path: "taxcode",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Taxcode",
                    meta: {
                        requiresAuth: true,
                    },
                    component: Taxcode,
                },
                {
                    path: "CreateTaxCode",
                    name: "CreateTaxCode",
                    meta: {
                        label: "Create TaxCode",
                        requiresAuth: true,
                    },
                    component: CreateTaxCode,
                },
                {
                    path: "ViewTaxCode",
                    name: "ViewTaxCode",
                    meta: {
                        label: "View TaxCode",
                        requiresAuth: true,
                    },
                    component: ViewTaxCode,
                },
                {
                    path: "EditTaxCode",
                    name: "EditTaxCode",
                    meta: {
                        label: "Edit TaxCode",
                        requiresAuth: true,
                    },
                    component: EditTaxCode,
                },
            ],
        },
        {
            path: "Coupon",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Coupon",
                    meta: {
                        requiresAuth: true,
                    },
                    component: Coupon,
                },
                {
                    path: "CreateCoupon",
                    name: "CreateCoupon",
                    meta: {
                        label: "Create Coupon",
                        requiresAuth: true,
                    },
                    component: CreateCoupon,
                },
                {
                    path: "EditCoupon",
                    name: "EditCoupon",
                    meta: {
                        label: "Edit Coupon",
                        requiresAuth: true,
                    },
                    component: EditCoupon,
                },
                {
                    path: "ViewCoupon",
                    name: "ViewCoupon",
                    meta: {
                        label: "View Coupon",
                        requiresAuth: true,
                    },
                    component: ViewCoupon,
                },
            ],
        },
        {
            path: "subscriptionplan",
            meta: {
                label: "Subscription",
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Subscription Plan",
                    meta: {
                        requiresAuth: true,
                    },
                    component: subscriptionplan,
                },
                {
                    path: "CreateSubscriptionplan",
                    name: "Create Subscriptionplan",
                    meta: {
                        requiresAuth: true,
                    },
                    component: CreateSubscriptionplan,
                },
                {
                    path: "EditSubscriptionplan",
                    name: "Edit Subscriptionplan",
                    meta: {
                        requiresAuth: true,
                    },
                    component: EditSubscriptionplan,
                },
                {
                    path: "Viewsubscriptionplan",
                    name: "View Subscriptionplan",
                    meta: {
                        requiresAuth: true,
                    },
                    component: ViewSubscriptionplan,
                },
            ],
        },
        {
            path: "deliverysetup",
            meta: {
                label: "Delivery Setup",
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Delivery Setup",
                    meta: {
                        requiresAuth: true,
                    },
                    component: deliverysetup,
                },
                {
                    path: "CreateDeliverysetup",
                    name: "Create Deliverysetup",
                    meta: {
                        requiresAuth: true,
                    },
                    component: CreateDeliverysetup,
                },
                {
                    path: "EditDeliverysetup",
                    name: "Edit Deliverysetup",
                    meta: {
                        requiresAuth: true,
                    },
                    component: EditDeliverysetup,
                },
                {
                    path: "ViewDeliverysetup",
                    name: "View Deliverysetup",
                    meta: {
                        requiresAuth: true,
                    },
                    component: ViewDeliverysetup,
                },
            ],
        },
        {
            path: "service-request",
            meta: {
                label: "Service Request",
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Service Request",
                    meta: {
                        requiresAuth: true,
                    },
                    component: Servicerequest,
                },
                {
                    path: "ViewRequest/:id",
                    meta: {
                        label: "View Request",
                        requiresAuth: true,
                    },
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "View Request",
                            meta: {
                                requiresAuth: true,
                            },
                            component: ViewRequest,
                        },
                        {
                            path: "Subcategory",
                            name: "Subcategory",
                            meta: {
                                requiresAuth: true,
                            },
                            component: Subcategory,
                        },
                    ],
                },
                {
                    path: "EditRequest/:id",
                    name: "Edit Request",
                    meta: {
                        requiresAuth: true,
                    },
                    component: EditRequest,
                },
                {
                    path: "CreateRequest",
                    name: "Create Request",
                    meta: {
                        requiresAuth: true,
                    },
                    component: CreateRequest,
                },
            ],
        },
        {
            path: "commission",
            name: "Commission Setup",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    meta: {
                        requiresAuth: true,
                    },
                    component: CommissionRuleList,
                },
                {
                    path: "create",
                    name: "Create",
                    meta: {
                        label: "Create",
                        requiresAuth: true,
                    },
                    component: createCommission,
                },
                {
                    path: "edit/:id",
                    name: "CommissionSetupEdit",
                    meta: {
                        label: "Edit",
                        requiresAuth: true,
                    },
                    component: editCommission,
                },
                {
                    path: "view/:id",
                    name: "CommissionSetupView",
                    meta: {
                        label: "View",
                        requiresAuth: true,
                    },
                    component: viewCommission,
                },
            ],
        },
        {
            path: "policy",
            name: "Return & Cancellation Policy",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "",
                    name: "Return & Cancellation Policy",
                    meta: {
                        requiresAuth: true,
                    },
                    component: ReturnPolicy,
                },
                {
                    path: "create",
                    name: "Create Return Policy",
                    meta: {
                        requiresAuth: true,
                    },
                    component: CreateReturnPolicy,
                },
                {
                    path: "edit/:id",
                    name: "Edit Return Policy",
                    meta: {
                        requiresAuth: true,
                    },
                    component: EditReturnPolicy,
                },
                {
                    path: "view/:id",
                    name: "View Return Policy",
                    meta: {
                        requiresAuth: true,
                    },
                    component: ViewReturnPolicy,
                },
            ],
        },
        ...workflows,
    ],
};
